export const Frontend = [
    {
      name: 'Reactjs',
      experience: 'intermediate'
    },
    {
      name: 'HTML5',
      experience: 'experienced'
    },
    {
      name: 'CSS',
      experience: 'intermediate'
    },
    {
      name: 'Bootstrap',
      experience: 'experienced'
    },
    {
      name: 'Javascript',
      experience: 'intermediate'
    }
  ];
  
  export const Backend = [
    {
      name: 'python',
      experience: 'intermediate'
    },
    {
      name: 'Django',
      experience: 'experienced'
    },
    {
      name: 'Rest-Framework',
      experience: 'experienced'
    },
    {
      name: 'Unit testing',
      experience: 'intermediate'
    },
    {
      name: 'NoSQL',
      experience: 'experienced'
    },
    {
      name: 'GIT',
      experience: 'experienced'
    }
  ];
  
  export const MachineLearning = [
    {
      name: 'Scikit-Learn',
      experience: 'intermediate'
    },
    {
      name: 'Tensorflow',
      experience: 'intermediate'
    },
    {
      name: 'Pandas',
      experience: 'intermediate'
    },
    {
      name: 'Numpy',
      experience: 'intermediate'
    }
  ];
  